'use strict';

function CnTableController($filter, $scope, $datepicker, $timepicker) {
  var vm = this;

  vm.$onInit = $onInit;
  vm._transformDate = _transformDate;


  function $onInit() {
    $scope.$watchCollection('vm.src', vm._transformDate);
  }

  function _transformDate() {
    if (vm.dateTimeField) {
      (vm.src || []).map(function (data) {
        if (data.hasOwnProperty(vm.dateTimeField)) {
          data.date = $filter('date')(data[vm.dateTimeField], $datepicker.defaults.dateFormat);
          data.time = $filter('date')(data[vm.dateTimeField], $timepicker.defaults.timeFormat);
        }
      });
    }
  }
}

module.exports = CnTableController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-table/cn-table.controller.js
 ** module id = 76
 ** module chunks = 0
 **/